import React from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import classNames from 'classnames';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';

import HistoricalPercentageChangeCapsuleCapsuleChartHelp from './HistoricalPercentageChangeCapsuleChartHelp.tsx';
import { useCapsuleBoundSymbol } from 'widgets/tiles/components/tile/hooks';
import { useHistoricalPercentageChangeCapsuleConfigSlice } from '../store';
import { useWidgetMessages } from 'widgets/store/stream/selectors.ts';
import { HistoricalPercentageChangeCapsuleContent } from 'widgets/historicalPercentageChange/capsule/components/HistoricalPercentageChangeCapsuleContent.tsx';
import {
    HistoricalPercentageChangeCapsuleSettings,
    HistoricalPercentageChangeCapsuleSettingsText,
} from 'widgets/historicalPercentageChange/capsule/components/HistoricalPercentageChangeCapsuleSettings.tsx';
import { histPriceVolStreamedDataSelectors } from 'widgets/historicalPercentageChange/store/data/streamSlice.ts';
import { initialHistPriceVolDataState } from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState.ts';

export function HistoricalPercentageChangeCapsule() {
    const { dispatchConfigChanged } =
        useHistoricalPercentageChangeCapsuleConfigSlice();

    const { symbol } = useCapsuleBoundSymbol();

    const { useWidgetStreamData } = histPriceVolStreamedDataSelectors;
    const streamData = useWidgetStreamData() ?? initialHistPriceVolDataState;

    const messages = useWidgetMessages();

    useWidgetStream();

    const cssClasses = classNames('HistoricalPercentageChangeCapsule');

    return (
        <WidgetTile className={cssClasses}>
            <TileToolbar
                title="% Change"
                settingsBody={<HistoricalPercentageChangeCapsuleSettings />}
                settingsHeader={HistoricalPercentageChangeCapsuleSettingsText}
                settingsClassName="HistoricalPercentageChangeCapsuleSettingsModal"
                preceedingItems={
                    <HistoricalPercentageChangeCapsuleCapsuleChartHelp />
                }
                messages={symbol ? messages : []}
                wideTitle={true}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus
                    warning={
                        <span>
                            Select a symbol or specify one in the&nbsp;
                            <ConfigSettingsModal
                                dispatcher={dispatchConfigChanged}
                                headerText={
                                    HistoricalPercentageChangeCapsuleSettingsText
                                }
                                triggerText={'Capsule Settings'}
                                renderSettings={(p) => (
                                    <HistoricalPercentageChangeCapsuleSettings
                                        {...p}
                                    />
                                )}
                            />
                            .
                        </span>
                    }
                >
                    <HistoricalPercentageChangeCapsuleContent
                        streamData={streamData}
                    />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );
}
